import React, { useState, useEffect } from "react";
import PopupForm from "./PopupForm.js";
import ServiceNav from "../components/ServiceNav";
import ServiceHero from "../components/ServiceHero";
import { FiCheckCircle, FiSearch, FiShield, FiFolder } from "react-icons/fi";
import { ServiceCta } from "../components/CtaSystem";
import "./CyberForensic.css";

const CyberForensic = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="cyber-forensic-container">
      {/* Hero Section */}
      <ServiceHero
        kicker="SERVICE 04"
        title="Data Forensic"
        description="Investigate cyber threats, recover digital evidence, and enhance cybersecurity."
        bgImage="/service4.png"
        onConnectClick={() => setIsPopupOpen(true)}
      />

      {/* About Cyber Forensics */}
      <section className="about-cf-section">
        <div className="about-content">
          <div className="vector-image">
            <img 
              src="./cb-img.png" 
              alt="Data Forensic Vector" 
            />
          </div>
          <div className="about-text">
            <h2>What is Data Forensic?</h2>
            <p>
              Data forensic, also known as digital forensics, is the process of collecting, analyzing, and preserving digital evidence from electronic devices to investigate cybercrimes, fraud, or data breaches. It helps in identifying unauthorized access, recovering lost data, and ensuring legal compliance in cybersecurity investigations.
            </p>
            <ul>
              <li><FiCheckCircle className="check-icon" /> Digital Evidence Collection</li>
              <li><FiCheckCircle className="check-icon" /> Data Recovery & Analysis</li>
              <li><FiCheckCircle className="check-icon" /> Cybercrime Investigation</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="features-section">
        <h2 className="section-title">Why Choose Our Data Forensic Solution?</h2>
        <div className="features-grid">
          <div className="feature-card">
            <span className="feature-icon"><FiSearch /></span>
            <h3>Digital Investigation</h3>
            <p>Advanced tools for analyzing cyber threats.</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon"><FiShield /></span>
            <h3>Data Security</h3>
            <p>Protect and recover compromised information.</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon"><FiFolder /></span>
            <h3>Evidence Management</h3>
            <p>Organized storage and retrieval of digital proof.</p>
          </div>
        </div>
      </section>

      {/* Service CTA */}
      <ServiceCta
        eyebrow="CYBER FORENSIC"
        heading="Secure Digital Evidence & Investigate Cyber Incidents"
        primaryBtnText="Connect Now!"
        onPrimaryClick={() => setIsPopupOpen(true)}
        secondaryBtnText="Contact Us"
        secondaryBtnLink="/contact-us"
      />

      {/* Service Navigation */}
      <ServiceNav currentPath="/cyber-forensic" />

      {/* Popup Form Component */}
      <PopupForm isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </div>
  );
};

export default CyberForensic;
